import { ReactNode } from 'react'

import { cn } from '@/utils/style'

interface StatsCardProps {
  title: ReactNode
  label: ReactNode
  value: string | number | ReactNode
  subLabel?: ReactNode
  subValue?: string | number | ReactNode
  onClick?: () => void
  showArrow?: boolean
  tooltip?: string
  statusLabel?: string
  statusColor?: string
  className?: string
}

export function StatsCard({
  title,
  value,
  label,
  subLabel,
  subValue,
  onClick,
  showArrow = false,
  className,
}: StatsCardProps) {
  const isClickable = onClick || showArrow

  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-panel-white rounded-2xl p-6 border border-neutral-200',
        isClickable && 'cursor-pointer hover:border-secondary transition-colors',
        className,
      )}
    >
      {/* Label with optional tooltip */}
      <div className="flex items-center gap-2 mb-4">
        <span className="t-lg">{title}</span>
      </div>

      {/* Value(s) */}
      <div className="flex">
        <div className="flex-1 flex flex-col gap-3 justify-center items-center">
          <div className="h3">{value}</div>
          <div className="flex gap-2 items-center">
            {subValue && <div className="rounded-full bg-success h-2 w-2"></div>}
            <div className="t-sb">{label}</div>
          </div>
        </div>
        {subValue && (
          <>
            <div className="self-center h-12 w-[1px] bg-neutral-200"></div>
            <div className="flex-1 flex flex-col gap-3 justify-center items-center">
              <div className="h3">{subValue}</div>
              <div className="t-sb">{subLabel}</div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
